<template>
    <div class="card card--patient appointment-reminder">
        <div v-if='appointment.cancelled_at'>
            <template v-if='appointment.start_at'>
                Your appointment on {{moment(appointment.start_at).format('LLLL')}}
            </template>
            <template v-else>
                Your appointment invitation
            </template>
            <p class='alert-warning' style='color: #0f435e;'>has been cancelled</p>
        </div>
        <template v-else>
            <p class='pb-2'>
                <span class='pb-2' v-if='appointment.start_at'>{{moment(appointment.start_at).format('LLLL')}}</span>
                <span class='pb-2' v-else>Invitation</span>
                
                {{translateLookupItem($root.lookup.appointment_types, appointment.appointment_type_id) | capitalise}} appointment with {{formatClinician(getAppointmentSessionTypeUser(appointment))}}
                <template v-if='appointment.site_id'> 
                    at {{appointment.site.name}}
                </template>
            </p>
            <template v-if='appointment.start_at'>
                <div class="d-flex justify-content-between mt-3">
                    <button v-on:click='deleteAppointment(appointment)' tag="button" class="btn btn-round btn-secondary">{{ $t('translations.cancel_appointment')}}</button>
                    <button v-on:click='$emit("edit_appointment")' class="btn btn-round btn-primary ml-auto">{{ $t('translations.change_booking')}}</button>
                </div>
            </template>
            <button v-if='showBook && !appointment.start_at' class="btn btn-sm btn-primary" v-on:click='$router.push({path: "/booking/" + appointment.id});'>Book Appointment</button>
        </template>
        
    </div>
</template>


<script>
	export default {
		props: {
            appointment: {
                
            },
            showBook: {
                default: false
            }
        },
		data: function(){
			return {
			};
		},
        mounted() {
        },
		computed: {

		},
		watch: {

		},
		methods: {
            deleteAppointment(appointment) {
            this.errors = [];
            this.$modal.show('dialog', {
					title: 'Cancel Appointment',
					text: "Are you sure you want to cancel this appointment?",
					buttons: [
					{
						title: 'Yes',
						handler: () => {
                            this.$modal.hide('dialog');
							this.setLoading(true);
                            return axios.delete(this.$root.apiBase + '/appointments/' + appointment.id).then((res) => {
                                this.setLoading(false);
                                //this.getAppointments();
                            }).catch((error) => {
                                this.setLoading(false);
                                this.handleError(error, "delete");
                            });
						},
					},
					{
						title: 'Cancel',
						default: true
					}]});                    
            },
        }
	}
</script>